import React from "react";
import {Route} from "react-router-dom";
import LibraryPack from "./LibraryPack";
import LibrarySeries from "./LibrarySeries";
import LibrarySpeaker from "./LibrarySpeaker";
import Library from "./Library";
import RascalPodcastGated, {RASCAL_PODCAST_PACK_IDS} from "./RoyalStarfish/RascalPodcastGated";

const RASCAL_PODCAST_PACK_ID_SET = new Set(
    Object.values(RASCAL_PODCAST_PACK_IDS).map(id => String(id))
);

function isRascalPodcastPackId(packId) {
    return RASCAL_PODCAST_PACK_ID_SET.has(String(packId));
}

function renderPackOrGated(prefix) {
    return ({match}) => {
        if (isRascalPodcastPackId(match?.params?.packId)) {
            return <RascalPodcastGated />;
        }
        return <LibraryPack prefix={prefix} />;
    };
}

function LibraryRoutes(prefix) {
    return [
        <Route path={`${prefix}/library/packs/:packId`}  render={renderPackOrGated(prefix)} />,
        <Route path={`${prefix}/library/series/:seriesId/packs/:packId`} render={renderPackOrGated(prefix)} />,
        <Route path={`${prefix}/library/series/:seriesId`} render={()=><LibrarySeries prefix={prefix} />}  />,
        <Route path={`${prefix}/library/speakers/:speakerId`} render={()=><LibrarySpeaker prefix={prefix} />}  />,
        <Route path={`${prefix}/library`} component={Library} />
    ]
}

export default LibraryRoutes